import React, {Component, memo} from 'react'
import PropTypes from 'prop-types'

import {processStringContent} from 'utils/content'


class Image extends Component {
    renderImage() {
        return (
            <div>
                <img
                    src={this.props.component_data.data.src}
                    alt={this.props.component_data.data.image_alt ? this.props.component_data.data.image_alt : undefined}/>
            </div>
        )
    }

    renderCaption() {
        if (this.props.component_data.data.caption) {
            return (
                <div>
                    {processStringContent(this.props.component_data.data.caption)}
                </div>
            )
        }
    }

    render() {
        return (
            <div className="challenge-component-image">
                <div className="flex-row flex-h-start">
                    <div className="flex-column flex-v-center flex-box-2-5 center-align">
                        {this.renderImage()}

                        {this.renderCaption()}
                    </div>
                </div>
            </div>
        )
    }
}

Image.propTypes = {
    component_data: PropTypes.object.isRequired
}

function arePropsEqual(oldProps, newProps) {
    return (
        oldProps.component_data.data.src === newProps.component_data.data.src && oldProps.component_data.data.caption === newProps.component_data.data.caption && oldProps.component_data.data.image_alt === newProps.component_data.data.image_alt
    );
}

export default memo(function (props) {
    return <Image {...props}/>
}, arePropsEqual);
